import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PeoplepulseService } from 'app/peoplepulse.service';
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
  selector: 'app-create-enrollment-dialog',
  standalone: true,
  templateUrl: './create-enrollment-dialog.component.html',
  styleUrls: ['./create-enrollment-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule
  ]
})
export class CreateEnrollmentDialogComponent implements OnInit, AfterViewInit {
  isLinear = true;
  @ViewChild('stepper') stepper!: MatStepper;

  // --- Form groups ---
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  thirdFormGroup!: FormGroup;
  fourthFormGroup!: FormGroup;
  fiveFormGroup!: FormGroup;
  sixFormGroup!: FormGroup;
  sevenFormGroup!: FormGroup;
  eightFormGroup!: FormGroup;

  today: string = '';
  // --- UI state ---
  isStepperVisible = false;
  showEsicUploads = false;
  showPfUploads = false;
  showUploadSection = false;
  // isLinear = false;
  isDisabled = false;
  manpowerData: any = null;
  selectedDesignationManpower: any = null;

  // --- Dropdown data ---
  branch_data: any[] = [];
  pcc_data: any[] = [];
  category_data: any[] = [];
  designation_data: any[] = [];
  PAPLdesignation_data: any[] = [];
  years: number[] = [];
  bloodGroups: string[] = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
  nationality: string[] = ['Indian', 'Foreign'];
  religion: string[] = ['Hindu', 'Muslim', 'Christian', 'Sikh', 'Others'];
  caste: string[] = ['SC', 'ST', 'OBC', 'General'];
  maritalStatus: string[] = ['Married', 'Unmarried', 'Widow', 'Widower'];
  bankNames: string[] = [
    'Bank of Baroda',
    'Bank of India',
    'Central Bank of India',
    'CANARA BANK',
    'Central Bank of India',
    'Indian Bank',
    'Indian Overseas Bank',
    'Punjab & Sind Bank',
    'Punjab National Bank',
    'State Bank of India',
    'UCO Bank',
    'Union Bank of India',
    'Axis Bank Ltd',
    'Bandhan Bank Ltd',
    'CSB Bank Ltd',
    'City Union Bank Ltd',
    'DCB Bank Ltd',
    'Dhanlaxmi Bank Ltd',
    'Federal Bank Ltd',
    'HDFC Bank Ltd',
    'ICICI Bank Ltd',
    'Induslnd Bank Ltd',
    'IDFC First Bank Ltd',
    'Jammu & Kashmir Bank Ltd',
    'Karnataka Bank Ltd',
    'Karur Vysya Bank Ltd',
    'Kotak Mahindra Bank Ltd',
    'Lakshmi Vilas Bank Ltd',
    'Nainital Bank Ltd',
    'Bank of India',
    'RBL Bank Ltd',
    'South Indian Bank Ltd',
    'Tamilnad Mercantile Bank Ltd',
    'YES Bank Ltd',
    'IDBI Bank Ltd',
    'Ujjivan Small Finance Bank',
    'India Post Payment Bank',
    'Chhattisgarh Rajya Gramin Bank',
    'AIRTEL PAYMENTS BANK',
    'FINO PAYMENTS BANK',
    'ODISHA STATE COOPERATIVE BANK',
    'EQUITAS SMALL FINANCE BANK',
    'BANK OF MAHARASHTRA',
    'KERALA GRAMIN BANK',
    'TJSB SAHAKARI BANK LTD',
    'SARASWAT CO-OPERATIVE BANK',
    'ABHYUDAYA CO-OP BANK LTD',
    'GP PARSIK BANK',
    'ANDHRA PRADESH GRAMEENA BANK',
    'DBS BANK INDIA LIMITED',
    'ARYAVART BANK',
    'Other'
  ];
  bloodRelations = [
    'SPOUSE',
    'MOTHER',
    'FATHER',
    'BROTHER',
    'SISTER',
    'UNMARRIED DAUGHTER',
    'SON'
  ];

  // Selected values
  branch_name: any = '';
  pcc_name: any = '';
  category_name: any = '';
  designation_name: any = '';
  papl_designation_name: any = '';
  branch_id: any = '';
  profit_cost_id: any = '';
  category_id: any = '';
  designation_id: any = '';
  PAPLdesignation_id: any = '';

  // --- IDs ---
  temp_emp_id: number | null = null;
  temp_id: number | null = null;
  sameAsPresentAddress: boolean = false;
  is_same_permanent_address: number = 0;
  educationType: string = '';
  qualificationStages: any[] = [];
  isEsic: boolean = false;
  epfEsicSaved = false;
  documentUploadCompleted = false;
  documentBase64: any = {
    qualification: [],
    family: []
  };

  constructor(
    private fb: FormBuilder,
    private peoplepulseService: PeoplepulseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEnrollmentDialogComponent>
  ) {
    this.dialogRef.disableClose = true;
  }

  // --------------------------------------------------------------------------
  // INIT
  // --------------------------------------------------------------------------

  ngOnInit(): void {
    const todayDate = new Date();
    const yyyy = todayDate.getFullYear();
    const mm = String(todayDate.getMonth() + 1).padStart(2, '0');
    const dd = String(todayDate.getDate()).padStart(2, '0');
    this.today = `${yyyy}-${mm}-${dd}`;

    this.isLinear = true;
    this.initForms();
    this.generateYears();

    if (this.data?.type === 'update') {
      this.loadDropdowns();
      this.isStepperVisible = true;
      this.patchFormData(this.data);
    }
  }

  ngAfterViewInit(): void {
    if (this.data?.type === 'update') {
      this.temp_id = this.data?.temp_id || this.data?.id;
      console.log('temp_id in ngAfterViewInit:', this.temp_id);
      setTimeout(() => {
        this.stepper.selectedIndex = 1;
        if (this.temp_id) {
          this.loadFamilyData(this.temp_id!);
          this.loadQualificationData(this.temp_id!);
        } else {
          console.warn('temp_id missing, skipping family load');
        }
      });
    }
  }


  // --------------------------------------------------------------------------
  // FORM INITIALIZATION
  // --------------------------------------------------------------------------

  initForms(): void {
    if (this.data?.type !== 'update') {
      this.firstFormGroup = this.fb.group({
        aadhaar_number: ['', [Validators.required, Validators.pattern(/^[0-9]{12}$/)]],
        dob: ['', Validators.required],
        aadhaar_name: ['', Validators.required],
      });
    }

    this.secondFormGroup = this.fb.group({
      temp_emp_id: [''],
      temp_id: [''],
      dob: [''],
      branch_id: [''],
      category_id: [''],
      profit_cost_id: [''],
      designation_id: [''],
      PAPLdesignation_id: [''],
      aadhaar_number: [''],
      aadhaar_name: [''],
      experience: ['', [Validators.pattern(/^[0-9]{1,2}$/)]],
      browse_experience: [''],
      father_husband_name: [''],
      relation_with_employee: [''],
      gender: [''],
      marital_status: [''],
      mobile_with_adhar: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      whatsapp_number: ['', [Validators.pattern(/^[0-9]{10}$/)]],
      email: [''],
      alternative_email: [''],
      browse_passport_photo: [''],
      browse_aadhaar: [''],
      permanent_addrs: [''],
      permanent_state: [''],
      permanent_district: [''],
      permanent_ps: [''],
      permanent_po: [''],
      permanent_village: [''],
      permanent_block: [''],
      permanent_tehsil: [''],
      permanent_gp: [''],
      permanent_pincode: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
      permanent_mobile_number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      present_address: [''],
      present_state: [''],
      present_district: [''],
      present_ps: [''],
      present_po: [''],
      present_village: [''],
      present_block: [''],
      present_tehsil: [''],
      present_gp: [''],
      present_pincode: ['', [Validators.pattern(/^[0-9]{6}$/)]],
      present_mobile_number: ['', [Validators.pattern(/^[0-9]{10}$/)]],
      blood_group: [''],
      ID_mark_employee: [''],
      nationality: [''],
      religion: [''],
      caste: [''],
      health_insurance_no: ['']
    });

    this.thirdFormGroup = this.fb.group({
      education_type: [''],
      qualifications: this.fb.array([])
    });

    this.fourthFormGroup = this.fb.group({
      name_bank: [''],
      other_bank_name: [{ value: '', disabled: true }],
      name_passbook: [''],
      ifsc: [''],
      bank_account_number: [''],
      name_branch: [''],
      pass_book_photo: ['']
    });

    this.fiveFormGroup = this.fb.group({
      nominee_name: [''],
      nominee_relation: [''],
      nominee_dob: [''],
      nominee_aadhaar_number: [''],
      nominee_aadhaar_photo: [''],
      nominee_address: ['']
    });

    this.sixFormGroup = this.fb.group({
      families: this.fb.array([this.createFamilyForm()])
    });

    this.sevenFormGroup = this.fb.group({
      esic_code: [''],
      esic_ip_number: [''],
      wca_gpa: [''],
      wca_gpa_expire_date: [''],
      esic_sheet: [''],
      esic_date: [''],
      pf_code: [''],
      uan: [''],
      pf_account_number: [''],
      form11_sheet: [''],
      uan_sheet: [''],
      epf_date: [''],
      epf_rule: [''],
      esic_status: [false],
      pf_status: [false]
    });

    this.eightFormGroup = this.fb.group({
      browse_experience: [''],
      browse_passport_photo: [''],
      browse_aadhaar: [''],
      pass_book_photo: [''],
      nominee_aadhaar_photo: [''],
      esic_sheet: [''],
      form11_sheet: [''],
      uan_sheet: ['']
    });
  }

  createQualificationForm(
    qualification: string = '',
    mandatory: boolean = false
  ): FormGroup {

    return this.fb.group({
      qualification: [qualification],

      university_board_name: [
        '',
        mandatory ? Validators.required : []
      ],

      college_institute_name: [
        '',
        mandatory ? Validators.required : []
      ],

      year_of_passout: [
        '',
        mandatory ? Validators.required : []
      ],

      division_percent: [
        '',
        mandatory ? Validators.required : []
      ],

      qualification_document: [
        '',
        mandatory ? Validators.required : []
      ],

      mandatory: [mandatory]
    });
  }

  get qualifications(): FormArray {
    return this.thirdFormGroup.get('qualifications') as FormArray;
  }

  addQualification(): void {
    if (this.educationType !== '10th_passout') return;
    this.qualifications.push(this.createQualificationForm('', false));
  }

  removeQualification(index: number): void {
    if (!this.thirdFormGroup) return;
    if (this.qualifications.length > 1) this.qualifications.removeAt(index);
  }

  loadQualificationData(temp_id: number): void {
    if (!temp_id) return;

    this.peoplepulseService.getQualificationByTempId(temp_id).subscribe({
      next: (res: any) => {
        const qualificationsArr = Array.isArray(res.data) ? res.data : res.data?.qualifications ?? [];
        const qa = this.qualifications;
        while (qa.length) qa.removeAt(0); // clear

        if (qualificationsArr.length) {
          qualificationsArr.forEach((q: any) => {
            const g = this.createQualificationForm();
            g.patchValue({
              university_board_name: q.university_board_name ?? '',
              college_institute_name: q.college_institute_name ?? '',
              year_of_passout: q.year_of_passout ?? '',
              division_percent: q.division_percent ?? '',
              qualification: q.qualification ?? ''
            });
            // store filename separately
            (g as any).existingFileName = q.qualification_document ?? null;
            qa.push(g);
          });
        } else {
          qa.push(this.createQualificationForm());
        }
      },
      error: (err) => {
        console.error('Error loading qualifications:', err);
      }
    });
  }


  get families(): FormArray {
    return this.sixFormGroup.get('families') as FormArray;
  }

  createFamilyForm(): FormGroup {
    return this.fb.group({
      family_member: [''],
      family_member_dob: [''],
      family_member_relation: [''],
      family_member_residence: [''],
      family_nominee_aadhaar_photo: ['']
    });
  }

  addFamily(): void {
    this.families.push(this.createFamilyForm());
  }

  removeFamily(index: number): void {
    if (this.families.length > 1) {
      this.families.removeAt(index);
    }
  }

  loadFamilyData(temp_id: number): void {
    console.log('Loading family data for temp_id:', temp_id);
    if (!temp_id) return;

    this.peoplepulseService.getFamilydetailsByTempId(temp_id).subscribe({
      next: (res: any) => {
        console.log('Family API Response:', res);
        const familyArr = Array.isArray(res.data)
          ? res.data
          : res.data?.families ?? [];

        const fa = this.families;
        while (fa.length) fa.removeAt(0);

        if (familyArr.length) {

          familyArr.forEach((f: any) => {
            const g = this.createFamilyForm();
            g.patchValue({
              family_member: f.family_member ?? '',
              family_member_dob: f.family_member_dob ?? '',
              family_member_relation: f.family_member_relation ?? '',
              family_member_residence: f.family_member_residence ?? '',
            });
            (g as any).existingFileName = f.family_nominee_aadhaar_photo ?? null;
            fa.push(g);
          });
        } else {
          fa.push(this.createFamilyForm());
        }
      },
      error: (err) => {
        console.error('Error loading family:', err);
      }
    });
  }

  disableAllForms(): void {
    [
      this.firstFormGroup,
      this.secondFormGroup,
      this.thirdFormGroup,
      this.fourthFormGroup,
      this.fiveFormGroup,
      this.sixFormGroup,
      this.sevenFormGroup
    ].forEach(fg => fg?.disable());
  }

  // --------------------------------------------------------------------------
  // PATCH EXISTING DATA
  // --------------------------------------------------------------------------

  patchFormData(data: any): void {
    if (!data) return;

    const masterData = { ...data };
    delete masterData.browse_experience;
    delete masterData.browse_passport_photo;
    delete masterData.browse_aadhaar;

    this.secondFormGroup.patchValue({
      temp_id: data.temp_id || '',
      temp_emp_id: data.temp_enrollment_id || '',
      aadhaar_number: data.aadhaar_number || '',
      aadhaar_name: data.aadhaar_name || '',
      dob: data.dob || '',
      branch_id: data.branch_id || '',
      branchname: data.branchname || '',
      profit_cost_id: data.profit_cost_id || '',
      pcc_name: data.pcc_name || '',
      category_id: data.category_id || '',
      designation_id: data.designation_id || '',
      designation_name: data.designation_name || '',
      PAPLdesignation_id: data.PAPLdesignation_id || data.papl_designation_id || '',
      papl_designation_name: data.papl_designation_name || '',
      experience: data.experience || '',
      browse_photo: data.browse_photo || '',
      father_husband_name: data.father_husband_name || '',
      relation_with_employee: data.relation_with_employee || '',
      gender: data.gender || '',
      marital_status: data.marital_status || '',
      mobile_with_adhar: data.mobile_with_adhar || '',
      whatsapp_number: data.whatsapp_number || '',
      email: data.email || '',
      alternative_email: data.alternative_email || '',
      browse_passport_photo: data.browse_passport_photo || '',
      browse_aadhaar: data.browse_aadhaar || '',
      permanent_addrs: data.permanent_addrs || '',
      permanent_state: data.permanent_state || '',
      permanent_district: data.permanent_district || '',
      permanent_ps: data.permanent_ps || '',
      permanent_po: data.permanent_po || '',
      permanent_village: data.permanent_village || '',
      permanent_block: data.permanent_block || '',
      permanent_tehsil: data.permanent_tehsil || '',
      permanent_gp: data.permanent_gp || '',
      permanent_pincode: data.permanent_pincode?.toString() || '',
      permanent_mobile_number: data.permanent_mobile_number || '',
      present_state: data.present_state || '',
      present_district: data.present_district || '',
      present_address: data.present_address || '',
      present_ps: data.present_ps || '',
      present_po: data.present_po || '',
      present_village: data.present_village || '',
      present_block: data.present_block || '',
      present_tehsil: data.present_tehsil || '',
      present_gp: data.present_gp || '',
      present_pincode: data.present_pincode?.toString() || '',
      present_mobile_number: data.present_mobile_number || '',
      blood_group: data.blood_group || '',
      ID_mark_employee: data.ID_mark_employee || '',
      nationality: data.nationality || '',
      religion: data.religion || '',
      caste: data.caste || '',
      health_insurance_no: data.health_insurance_no || '',
      browse_ctc: data.browse_ctc || '',
      status_approval_log: data.status_approval_log || '',
      comment: data.comment || '',
    });

    this.branch_id = data.branch_id || '';
    this.category_id = data.category_id || '';
    this.profit_cost_id = data.profit_cost_id || '';
    this.designation_id = data.designation_id || '';
    this.PAPLdesignation_id = data.PAPLdesignation_id || data.papl_designation_id || '';
    const isSameAddress = Number(data.is_same_permanent_address) === 1;
    this.sameAsPresentAddress = isSameAddress;
    this.is_same_permanent_address = isSameAddress ? 1 : 0;
    if (isSameAddress) {
      this.sameAsPresent();
    }

    if (this.data?.type === 'update') {

      if (this.branch_id) {
        this.peoplepulseService.getPccByBranch(this.branch_id).subscribe({
          next: (res: any) => {
            this.pcc_data = res.data || res || [];
            this.secondFormGroup.patchValue({
              branch_id: this.branch_id,
              profit_cost_id: this.profit_cost_id
            });
          },
          error: (err) => {
            console.error('PCC load error:', err);
          }
        });
      }

      if (this.category_id) {
        this.peoplepulseService.getCategoryByDesignation(this.category_id).subscribe({
          next: (res: any) => {
            this.designation_data = res.data || res || [];
            this.secondFormGroup.patchValue({
              category_id: this.category_id,
              designation_id: this.designation_id
            });
          },
          error: (err) => {
            console.error('Designation load error:', err);
          }
        });
      }

      if (!this.PAPLdesignation_data.length) {
        this.peoplepulseService.getAllPaplDesignation().subscribe({
          next: (res: any) => {
            this.PAPLdesignation_data = res.data || res || [];
            this.secondFormGroup.patchValue({
              PAPLdesignation_id: this.PAPLdesignation_id
            });
          },
          error: (err) => {
            console.error('PAPLdesignation load error:', err);
          }
        });
      } else {
        this.secondFormGroup.patchValue({
          PAPLdesignation_id: this.PAPLdesignation_id
        });
      }
    }


    if (data.qualification) {
      const { qualification_document, ...qualificationData } = data.qualification;
      this.thirdFormGroup.patchValue(qualificationData);
    }

    if (data.bank_details) {
      const { pass_book_photo, ...bankData } = data.bank_details;
      this.fourthFormGroup.patchValue(bankData);
    }

    if (data.bank_details?.name_bank === 'Other') {
      this.fourthFormGroup.get('other_bank_name')?.enable();
      this.fourthFormGroup.get('other_bank_name')?.updateValueAndValidity();
    }

    if (data.nominee) {
      const { nominee_aadhaar_photo, ...nomineeData } = data.nominee;
      this.fiveFormGroup.patchValue(nomineeData);
    }

    if (data.family_details) {
      const { family_nominee_aadhaar_photo, ...familyData } = data.family_details;
      this.sixFormGroup.patchValue(familyData);
    }

    if (data.epf_esic) {
      const { form11_sheet, uan_sheet, esic_sheet, ...epfData } = data.epf_esic;
      this.sevenFormGroup.patchValue(epfData);
      if (epfData.wca_gpa) {
        this.onWcaGpaChange({
          value: epfData.wca_gpa
        });
      }
    }
  }

  // --------------------------------------------------------------------------
  // CREATE / UPDATE SUBMISSIONS
  // --------------------------------------------------------------------------

  onSubmitEmployment(): void {
    if (this.firstFormGroup.invalid) {
      this.firstFormGroup.markAllAsTouched();
      alert("Please fill all required fields correctly.");
      return;
    }

    const payload = this.firstFormGroup.value;

    // CREATE EMPLOYMENT

    this.peoplepulseService.createEmployment(payload).subscribe({
      next: (res: any) => {
        const data = res?.data || {};
        this.temp_emp_id = data?.temp_enrollment_id || null;
        this.temp_id = data?.id || null;

        this.secondFormGroup.patchValue({
          temp_emp_id: this.temp_emp_id,
          aadhaar_number: data.aadhaar_number || '',
          aadhaar_name: data.aadhaar_name || '',
          dob: data.dob || ''
        });
        this.loadDropdowns();
        this.isStepperVisible = true;
      },
      error: (err) => {
        alert(err.error.message);
      }
    });
  }

  // --- MASTER DETAILS CREATE/UPDATE ---

  onSubmitMaster(): void {
    const payload = {
      ...this.secondFormGroup.getRawValue(),
      is_same_permanent_address: this.is_same_permanent_address,
    };

    if (this.data?.type === 'update' && this.data?.temp_enrollment_id) {
      payload.temp_enrollment_id = this.data.temp_enrollment_id;
    }
    payload.temp_id = this.temp_id || payload.temp_id || this.data?.id || '';
    payload.temp_emp_id = this.temp_emp_id || payload.temp_emp_id || this.data?.temp_enrollment_id || '';

    if (this.data?.type === 'update') {
      this.peoplepulseService.createMaster(payload).subscribe({
        next: () => alert('Master details updated successfully!'),
        error: (err) => {
          alert(err.error.message);
          console.error('Error updating master details:', err.error.message);
        }
      });
    } else {
      this.peoplepulseService.createMaster(payload).subscribe({
        next: (res: any) => {
          alert('Master details saved successfully!');
          const data = res?.data || {};
          this.temp_id = data?.id || this.temp_id;
          this.temp_emp_id = data?.temp_enrollment_id || this.temp_emp_id;
          console.log(data, 'data data datadata');

          this.thirdFormGroup.patchValue({ temp_id: this.temp_id });
          this.fourthFormGroup.patchValue({ temp_id: this.temp_id });
          this.fiveFormGroup.patchValue({ temp_id: this.temp_id });
          this.sixFormGroup.patchValue({ temp_id: this.temp_id });
          this.sevenFormGroup.patchValue({ temp_id: this.temp_id });
        },
        error: (err) => {
          alert(err.error.message);
          console.error('Error Create master details:', err.error.message);
        }
      });
    }
  }


  // --- QUALIFICATION CREATE/UPDATE ---

  onSubmitQualification(): void {
    if (!this.validateQualificationYears()) return;
    if (!this.validateQualificationWithDOB()) return;
    if (!this.temp_id) {
      alert("Temp ID not found — please complete previous steps first.");
      return;
    }
    const qualifications = this.qualifications.controls.map((q, i) => {
      const qVal = q.value;
      const existingFileName = (q as any).existingFileName || null;
      const file = this.selectedFiles?.[i];
      return {
        university_board_name: qVal.university_board_name || '',
        college_institute_name: qVal.college_institute_name || '',
        year_of_passout: qVal.year_of_passout || '',
        division_percent: qVal.division_percent || '',
        qualification: qVal.qualification || '',
        qualification_document: file ? file.name : existingFileName || ''
      };
    });
    const payload = {
      temp_id: this.temp_id,
      qualifications: qualifications
    };
    this.peoplepulseService.createQualification(payload).subscribe({
      next: () => {
        alert(this.data?.type === 'update' ? 'Qualifications updated successfully!' : 'Qualifications saved successfully!');
        if (this.stepper) this.stepper.next();
      },
      error: (err) => {
        alert(err?.error?.message || 'Error saving qualifications.');
        console.error('Error saving qualifications:', err);
      }
    });
  }

  // --- BANK CREATE/UPDATE ---

  onSubmitBank(): void {
    const payload = { ...this.fourthFormGroup.value, temp_id: this.temp_id };

    if (this.data?.type === 'update') {
      this.peoplepulseService.createBankdetails(payload).subscribe({
        next: () => alert('Bank details updated!'),
        error: (err) => {
          alert(err.error.message);
          console.error('Error updating bank details:', err.error.message);
        }
      });
    } else {
      this.peoplepulseService.createBankdetails(payload).subscribe({
        next: () => alert('Bank details saved!'),
        error: (err) => {
          alert(err.error.message);
          console.error('Error Create bank details:', err.error.message);
        }
      });
    }
  }

  // --- NOMINEE CREATE/UPDATE ---

  onSubmitNominee(): void {
    const payload = { ...this.fiveFormGroup.value, temp_id: this.temp_id };

    if (this.data?.type === 'update') {
      this.peoplepulseService.createNomineedetails(payload).subscribe({
        next: () => alert('Nominee updated!'),
        error: (err) => {
          alert(err.error.message);
          console.error('Error update nominee details:', err.error.message);
        }
      });
    } else {
      this.peoplepulseService.createNomineedetails(payload).subscribe({
        next: () => alert('Nominee saved!'),
        error: (err) => {
          alert(err.error.message);
          console.error('Error create nominee details:', err.error.message);
        }
      });
    }
  }

  // --- FAMILY CREATE/UPDATE ---

  onSubmitFamily(): void {
    const familyArray = this.sixFormGroup.value.families;
    if (!familyArray.length) {
      alert('Please add at least one family member.');
      return;
    }

    const families = this.families.controls.map((f, i) => {
      const fVal = f.value;
      const existingFileName = (f as any).existingFileName || null;
      const file = this.selectedFiles?.[i];

      return {
        family_member: fVal.family_member || '',
        family_member_dob: fVal.family_member_dob || '',
        family_member_relation: fVal.family_member_relation || '',
        family_member_residence: fVal.family_member_residence || '',
        family_nominee_aadhaar_photo: file
          ? file.name
          : existingFileName || ''
      };
    });

    const payload = {
      temp_id: this.temp_id,
      family_details: families
    };

    console.log("Final payload before send:", payload);

    this.peoplepulseService.createFamilydetails(payload).subscribe({
      next: () => {
        alert(this.data?.type === 'update' ? 'Family updated successfully!' : 'Family saved successfully!');

        if (this.stepper) {
          this.stepper.next();
        }
      },
      error: (err) => {
        alert(err?.error?.message || 'Error saving Family.');
        console.error('Error saving Family:', err);
      }
    });
  }

  selectedFiles: { [key: number]: File } = {};

  onFileSelected(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFiles[index] = file;
    }
  }

  onFileSelectedFamily(event: any, index: number): void {
    const file = event.target.files?.[0];
    if (file) {
      this.families.at(index).patchValue({
        family_nominee_aadhaar_photo: file.name
      });
    }
  }

  // --- EPF/ESIC CREATE/UPDATE ---

  onSubmitEpfEsic(): void {
    const payload = { ...this.sevenFormGroup.value, temp_id: this.temp_id };

    if (!this.temp_id) {
      alert('Temporary ID missing. Please complete previous steps first.');
      return;
    }
    this.peoplepulseService.createEpfesicdetails(payload).subscribe({
      next: () => {
        this.epfEsicSaved = true;
        if (this.data?.type === 'update') {
          alert('EPF & ESIC details updated successfully!');
        } else {
          alert('EPF & ESIC details saved successfully!');
        }
        if (this.stepper) {
          this.stepper.next();
        }
      },
      error: (err) => {
        alert(err?.error?.message || 'Error saving EPF & ESIC details.');
        console.error('Error saving EPF & ESIC details:', err);
      }
    });
  }


  // --------------------------------------------------------------------------
  // RESET & DROPDOWNS
  // --------------------------------------------------------------------------

  onReset(): void {
    [
      this.firstFormGroup,
      this.secondFormGroup,
      this.thirdFormGroup,
      this.fourthFormGroup,
      this.fiveFormGroup,
      this.sixFormGroup,
      this.sevenFormGroup,
      this.eightFormGroup
    ].forEach(fg => fg?.reset());
    this.temp_emp_id = null;
    this.temp_id = null;
    alert('Form reset complete.');
  }

  loadDropdowns(): void {
    this.peoplepulseService.getAllBranch().subscribe({
      next: res => this.branch_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('Branch load error:', err.error.message);
      }
    });
    this.peoplepulseService.getAllCategory().subscribe({
      next: res => this.category_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('Category load error:', err.error.message);
      }
    });
    this.peoplepulseService.getAllPaplDesignation().subscribe({
      next: res => this.PAPLdesignation_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('PAPLdesignation load error:', err.error.message);
      }
    });
  }
  onBranchChange(branchId: number): void {
    this.branch_name = branchId;
    this.profit_cost_id = '';
    this.pcc_data = [];

    this.peoplepulseService.getPccByBranch(branchId).subscribe({
      next: (res: any) => this.pcc_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('PCC load error:', err.error.message);
      }
    });
  }

  onDesignationChange(categoryId: number): void {
    this.selectedDesignationManpower = null;
    this.category_name = categoryId;
    this.category_id = null;
    this.designation_data = [];
    this.peoplepulseService.getCategoryByDesignation(categoryId).subscribe({
      next: (res: any) => this.designation_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('Designation load error:', err.error.message);
      }
    });
  }
  onProfitCostChange(profit_cost_id: number): void {
    if (!profit_cost_id) return;
    this.peoplepulseService.getCapacity(profit_cost_id).subscribe({
      next: (res: any) => {
        const resdata = res?.data;
        this.manpowerData = resdata;
        if (resdata.manpower_left_pccc == 0) {
          alert("Please contact administrator/management to increase capacity of Profit Cost Center")
          this.isDisabled = true;
        }
        else {
          this.isDisabled = false;
        }
      },
      error: (err) => {
        alert(err.error.message);
      }
    });
  }

  onChange(designationId: number): void {
    if (!this.profit_cost_id) return;
    this.peoplepulseService.getCapacity(this.profit_cost_id, designationId).subscribe({
      next: (res: any) => {
        const resdata = res?.data;
        this.selectedDesignationManpower = {
          max: resdata?.total_manpower ?? 0,
          current: resdata?.current_manpower ?? 0,
          left: resdata?.manpower_left ?? 0
        };
      }
    });
  }


  generateYears(): void {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1950; y--) this.years.push(y);
  }

  toggleEsicUpload(): void {
    this.showEsicUploads = !this.showEsicUploads;
  }

  togglePfUpload(): void {
    this.showPfUploads = !this.showPfUploads;
  }

  sameAsPresent(event?: any): void {
    const isChecked = event?.target?.checked ?? true;
    this.is_same_permanent_address = isChecked ? 1 : 0;
    if (isChecked) {
      this.secondFormGroup.patchValue({
        permanent_addrs: this.secondFormGroup.get('present_address')?.value,
        permanent_state: this.secondFormGroup.get('present_state')?.value,
        permanent_district: this.secondFormGroup.get('present_district')?.value,
        permanent_ps: this.secondFormGroup.get('present_ps')?.value,
        permanent_po: this.secondFormGroup.get('present_po')?.value,
        permanent_village: this.secondFormGroup.get('present_village')?.value,
        permanent_block: this.secondFormGroup.get('present_block')?.value,
        permanent_tehsil: this.secondFormGroup.get('present_tehsil')?.value,
        permanent_gp: this.secondFormGroup.get('present_gp')?.value,
        permanent_pincode: this.secondFormGroup.get('present_pincode')?.value,
        permanent_mobile_number: this.secondFormGroup.get('present_mobile_number')?.value
      });
      this.sameAsPresentAddress = true;
    } else {
      this.sameAsPresentAddress = false;
    }
  }

  closeDialog(): void {
    if (this.epfEsicSaved && !this.documentUploadCompleted) {
      alert('Please complete Document Uploads before closing.');
      return;
    }
    if (this.data?.type === 'update') {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close(false);
    }
  }

  onBankChange(event: any): void {
    const otherBankControl = this.fourthFormGroup.get('other_bank_name');
    if (event.value === 'Other') {
      otherBankControl?.enable();
      otherBankControl?.setValidators([Validators.required]);
    } else {
      otherBankControl?.reset();
      otherBankControl?.disable();
      otherBankControl?.clearValidators();
    }
    otherBankControl?.updateValueAndValidity();
  }

  onEducationTypeChange(type: string): void {
    this.educationType = type;
    const qualificationArray = this.qualifications;
    while (qualificationArray.length) qualificationArray.removeAt(0);
    if (type === 'below_10th') {
      qualificationArray.push(this.createQualificationForm('8th Standard', true));
    } else if (type === '10th_passout') {
      qualificationArray.push(this.createQualificationForm('10th Standard', true));
      qualificationArray.push(this.createQualificationForm('+2 / ITI', true));
      qualificationArray.push(this.createQualificationForm('Graduation', false));
      qualificationArray.push(this.createQualificationForm('Post Graduation', false));
    }
  }

  validateQualificationWithDOB(): boolean {
    const dob = this.secondFormGroup.get('dob')?.value;
    if (!dob) return true;
    const birthYear = new Date(dob).getFullYear();
    const qualifications = this.qualifications.getRawValue();
    const ageRules: any = {
      '8th Standard': { min: 11, max: 16 },
      '10th Standard': { min: 13, max: 18 },
      '+2 / ITI': { min: 15, max: 20 },
      'Graduation': { min: 17, max: 30 },
      'Post Graduation': { min: 20, max: 35 }
    };
    for (const q of qualifications) {
      if (!q.year_of_passout || !q.qualification) continue;
      const passoutYear = Number(q.year_of_passout);
      const ageAtPassout = passoutYear - birthYear;
      const rule = ageRules[q.qualification];
      if (!rule) continue;
      if (ageAtPassout < rule.min || ageAtPassout > rule.max) {
        alert(
          `${q.qualification} passout year is invalid according to DOB.\n` +
          `Expected age should be between ${rule.min} and ${rule.max} years.\n` +
          `Current age at passout: ${ageAtPassout} years.`
        );
        return false;
      }
    }
    return true;
  }

  validateQualificationYears(): boolean {
    const qualifications = this.qualifications.getRawValue();
    const getYear = (qualification: string) => {
      return qualifications.find((q: any) => q.qualification === qualification)?.year_of_passout;
    };
    const year8 = Number(getYear('8th Standard'));
    const year10 = Number(getYear('10th Standard'));
    const year12 = Number(getYear('+2 / ITI'));
    const grad = Number(getYear('Graduation'));
    const postGrad = Number(getYear('Post Graduation'));
    if (year8 && year10 && year8 >= year10) {
      alert('10th passout year must be greater than 8th passout year');
      return false;
    }
    if (year10 && year12 && year10 >= year12) {
      alert('+2 / ITI passout year must be greater than 10th passout year');
      return false;
    }
    if (year12 && grad && year12 >= grad) {
      alert('Graduation passout year must be greater than +2 / ITI passout year');
      return false;
    }
    if (grad && postGrad && grad >= postGrad) {
      alert('Post Graduation passout year must be greater than Graduation passout year');
      return false;
    }
    return true;
  }

  onWcaGpaChange(event: any): void {
    const esicCodeControl = this.sevenFormGroup.get('esic_code');
    const esicIpControl = this.sevenFormGroup.get('esic_ip_number');
    const esicDateControl = this.sevenFormGroup.get('esic_date');
    if (event.value === 'WCA' || event.value === 'GPA') {
      esicCodeControl?.reset();
      esicIpControl?.reset();
      esicDateControl?.reset();
      esicCodeControl?.disable();
      esicIpControl?.disable();
      esicDateControl?.disable();
    } else {
      esicCodeControl?.enable();
      esicIpControl?.enable();
      esicDateControl?.enable();
    }
    esicCodeControl?.updateValueAndValidity();
    esicIpControl?.updateValueAndValidity();
    esicDateControl?.updateValueAndValidity();
  }

  onSubmitDocuments(): void {
    const payload = {
      temp_id: this.temp_id,
      ...this.eightFormGroup.value
    };
    this.peoplepulseService.saveAllEnrolmentDocs(this.temp_id, payload).subscribe({
      next: (res) => {
        this.documentUploadCompleted = true;
        if (this.data?.type === 'update') {
          alert('Documents updated successfully!');
        } else {
          alert('Documents saved successfully!');
        }
        this.dialogRef.close(true);
      },
      error: (err) => {
        alert(err?.error?.message || 'Error saving Documents.');
        console.error('Error saving Documents:', err);
      }
    });
  }

  onDocumentSelected(event: any, fieldName: string): void {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      this.documentBase64[fieldName] = reader.result;
    };
    reader.readAsDataURL(file);
  }

  onQualificationDocumentSelected(event: any, index: number) {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      this.documentBase64.qualification[index] = {
        qualification: this.qualifications.at(index).get('qualification')?.value,
        qualification_document: reader.result
      };
    };
    reader.readAsDataURL(file);
  }

  onFamilyDocumentSelected(event: any, index: number) {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      this.documentBase64.family[index] = {
        family_member: this.families.at(index).get('family_member')?.value,
        family: reader.result
      };
    };
    reader.readAsDataURL(file);
  }

  submitDocuments(): void {
    if (!this.temp_id) {
      alert('Temporary Enrollment ID not found');
      return;
    }
    const payload = {
      browse_experience: this.documentBase64.browse_experience,
      browse_passport_photo: this.documentBase64.browse_passport_photo,
      browse_aadhaar: this.documentBase64.browse_aadhaar,
      pass_book_photo: this.documentBase64.pass_book_photo,
      nominee_aadhaar_photo: this.documentBase64.nominee_aadhaar_photo,
      esic_sheet: this.documentBase64.esic_sheet,
      form11_sheet: this.documentBase64.form11_sheet,
      uan_sheet: this.documentBase64.uan_sheet,
      qualification: this.documentBase64.qualification,
      family: this.documentBase64.family
    };
    this.peoplepulseService.saveAllEnrolmentDocs(this.temp_id, payload).subscribe({
      next: (res: any) => {
        this.documentUploadCompleted = true;
        alert('Documents uploaded successfully');
        this.dialogRef.close(true);
      },
      error: (err) => {
        alert(err?.error?.message || 'Upload failed');
      }
    });
  }
}
